<div class="progress-container">
  @for (status of progress(); track $index) {
    <div class="status-block">

      <!-- Rejection reasons card -->
      @if (!status.declined && ($index === ProgressStatusIndex.REJECTED) && (status.isActive || isManuallyIssued())) {
        <mat-card class="rejection-card">
          @for (
            error of rejectionReasons() | keyvalue: originalOrder; track $index) {
            <div class="rejection-line">
              <mat-icon
                [class]="error.value.isOk ? 'positive' : 'negative'">
                {{ error.value.isOk ? 'check' : 'close' }}
              </mat-icon>
              <div>{{ error.value.name }}</div>
            </div>
          }
        </mat-card>
      }

      <!-- Status name -->
      <div class="status-name">
        @for (name of status.name; track $index) {
          <div class="status-name-line">{{ name }}</div>
        }
      </div>

      <!-- Status icon -->
      @if ($index === ProgressStatusIndex.APPROVED && status.isActive) {
        <mat-icon class="positive">check_circle</mat-icon>
      } @else if ($index === ProgressStatusIndex.REJECTED && status.isActive) {
        <mat-icon class="negative">cancel</mat-icon>
      } @else if (status.isDone) {
        <mat-icon class="positive">check_circle</mat-icon>
      } @else if (status.isActive) {
        <mat-icon class="yellow-icon">radio_button_checked</mat-icon>
      } @else {
        <mat-icon class="status-inactive">radio_button_unchecked</mat-icon>
      }
    </div>

    <!-- Progress line -->
    @if (!$last) {
      <div class="progress-line" [class.done]="status.isDone"></div>
    }
  }
</div>